// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IapUGb_Cq2VzSr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 0;
  column-gap: 4px;
}
.IapUGb_Cq2VzSr.NGWx7QMH8yhLb3 {
  margin-top: -8px;
  padding: 0 8px;
}
.IapUGb_Cq2VzSr[hidden] {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listFooter": `IapUGb_Cq2VzSr`,
	"isHoverGapEnabled": `NGWx7QMH8yhLb3`
};
export default ___CSS_LOADER_EXPORT___;
